import React, { useEffect, useState } from 'react';
import { Modal } from 'bootstrap';
import { db, collection, getDocs } from '../../utils/firebase';

const OrderModal = ({ initialProductId = '' }) => {
  const [voucherDiscount, setVoucherDiscount] = useState(0);
  const [voucherError, setVoucherError] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(initialProductId);
  const [totalPrice, setTotalPrice] = useState({ original: 0, discount: 0, final: 0 });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const productPrices = {
    '1': { 
      price: 6990000, 
      name: 'Gói 2 tháng - 6.990.000đ',
      isActive: true 
    },
    '2': { 
      price: 20340000, 
      name: 'Gói 6 tháng - 20.340.000đ (Giảm 3%)',
      isActive: true 
    },
    '3': { 
      price: 34950000, 
      name: 'Gói 12 tháng - 34.950.000đ (Mua 5 tặng 1)',
      isActive: true 
    }
  };

  useEffect(() => {
    const orderModal = document.getElementById('orderModal');
    // const bsOrderModal = Modal.getInstance(orderModal) || new Modal(orderModal);

    // Handle modal show event
    orderModal.addEventListener('show.bs.modal', () => {
      // Get the product ID from data attribute
      const productId = orderModal.getAttribute('data-product-id') || '';
      setSelectedProduct(productId);
      if (productId) {
        setTotalPrice(calculateTotalPrice(productId, 0));
      }
      // Reset voucher states
      setVoucherDiscount(0);
      setVoucherError('');
    });

    // Handle modal close event
    orderModal.addEventListener('hidden.bs.modal', () => {
      // Remove modal backdrop
      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.remove();
      }
      // Remove modal-open class from body
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      // Remove the data attribute
      orderModal.removeAttribute('data-product-id');
    });

    return () => {
      // Cleanup event listeners
      orderModal.removeEventListener('show.bs.modal', () => {});
      orderModal.removeEventListener('hidden.bs.modal', () => {});
    };
  }, []);

  // Add effect to update price when initial product changes
  useEffect(() => {
    if (initialProductId) {
      setSelectedProduct(initialProductId);
      setTotalPrice(calculateTotalPrice(initialProductId, voucherDiscount));
    }
  }, [initialProductId, voucherDiscount]);

  const calculateTotalPrice = (productId, discount) => {
    if (!productId || !productPrices[productId]) return { original: 0, discount: 0, final: 0 };
    const originalPrice = productPrices[productId].price;
    const discountAmount = originalPrice * (discount / 100);
    const finalPrice = originalPrice - discountAmount;
    return {
      original: originalPrice,
      discount: discountAmount,
      final: finalPrice
    };
  };

  const handleProductChange = (e) => {
    const productId = e.target.value;
    setSelectedProduct(productId);
    if (productId) {
      setTotalPrice(calculateTotalPrice(productId, voucherDiscount));
    } else {
      setTotalPrice({ original: 0, discount: 0, final: 0 });
    }
  };

  // Add effect to update price when product is selected
  useEffect(() => {
    if (selectedProduct) {
      setTotalPrice(calculateTotalPrice(selectedProduct, voucherDiscount));
    }
  }, [selectedProduct, voucherDiscount]);

  const checkVoucher = async (voucherCode) => {
    try {
      const querySnapshot = await getDocs(collection(db, 'vouchers'));
      const vouchers = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      const validVoucher = vouchers.find(v => 
        v.code === voucherCode && 
        v.status === 'active' && 
        new Date(v.expiryDate) > new Date()
      );

      if (validVoucher) {
        const discount = parseInt(validVoucher.discount);
        setVoucherDiscount(discount);
        setVoucherError('');
        setTotalPrice(calculateTotalPrice(selectedProduct, discount));
        return true;
      } else {
        setVoucherDiscount(0);
        setVoucherError('Mã giảm giá không hợp lệ hoặc đã hết hạn');
        setTotalPrice(calculateTotalPrice(selectedProduct, 0));
        return false;
      }
    } catch (error) {
      console.error('Error checking voucher:', error);
      setVoucherError('Có lỗi xảy ra khi kiểm tra mã giảm giá');
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const name = document.getElementById('customerName').value;
      const phone = document.getElementById('customerPhone').value;
      const content = document.getElementById('orderContent').value;
      const voucher = document.getElementById('voucherCode').value;
      const prediscount = productPrices[selectedProduct].price.toLocaleString();

      if (!name || !phone || !selectedProduct) {
        alert('Vui lòng điền đầy đủ thông tin');
        return;
      }

      if (voucher && !await checkVoucher(voucher)) {
        return;
      }

      const productName = productPrices[selectedProduct].name + 
        (voucherDiscount > 0 ? ` (Giảm thêm ${voucherDiscount}%)` : '');

      const voucherDetail = voucher ? `Mã giảm giá: ${voucher} - Giảm ${voucherDiscount}%` : '';
      const originalPrice = `Giá gốc: ${productPrices[selectedProduct].price.toLocaleString()}đ`
      const formData = new FormData();
      formData.append('entry.1950963733', productName);
      formData.append('entry.253941401', name);
      formData.append('entry.359923773', phone);
      formData.append('entry.229206255', content);
      formData.append('entry.540200482', voucherDetail);
      formData.append('entry.2087550672', originalPrice);
      formData.append('entry.1783879486', 
        `Giá gốc: ${productPrices[selectedProduct].price.toLocaleString()}đ - Giá sau giảm: ${totalPrice.final.toLocaleString()}đ`
      );

      await fetch('https://docs.google.com/forms/d/e/1FAIpQLSfz8KMlVjTdH9wMgsvNjKzMMTIC5-eaNvho4FvbU0iR8f2UKw/formResponse', {
        method: 'POST',
        body: formData,
        mode: 'no-cors'
      });
      
      const orderModal = document.getElementById('orderModal');
      const successModal = document.getElementById('successModal');
      const bsOrderModal = Modal.getInstance(orderModal);
      const bsSuccessModal = new Modal(successModal);
      
      bsOrderModal.hide();
      document.getElementById('orderForm').reset();
      bsSuccessModal.show();
    } catch (error) {
      console.error('Error:', error);
      alert('Có lỗi xảy ra khi gửi đơn hàng. Vui lòng thử lại.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="modal fade" id="orderModal" tabIndex="-1" aria-labelledby="orderModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content" style={{ borderRadius: '15px', border: 'none' }}>
          <div className="modal-header" 
               style={{ 
                 background: 'linear-gradient(to right, #5de0e6, #004aad)', 
                 borderRadius: '15px 15px 0 0', 
                 border: 'none' 
               }}>
            <h5 className="modal-title text-white" id="orderModalLabel">{process.env.REACT_APP_API_URL || 'Đặt hàng'}</h5>
            <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body" style={{ padding: '2rem' }}>
            <form id="orderForm" onSubmit={handleSubmit}>
              <div className="row">
                {/* Single Column - Product, Voucher, and Customer Information */}
                <div className="col-md-12">
                  {/* Product Selection */}
                  <div className="mb-2">
                    <label htmlFor="productSelect" className="form-label">Chọn sản phẩm</label>
                    <select 
                      className="form-select" 
                      id="productSelect" 
                      value={selectedProduct}
                      onChange={handleProductChange}
                      required
                    >
                      <option value="">-- Chọn sản phẩm --</option>
                      {Object.entries(productPrices).map(([id, { name, isActive }]) => (
                        <option 
                          key={id} 
                          value={id}
                          disabled={!isActive}
                        >
                          {name} {!isActive ? '(Tạm hết hàng)' : ''}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Customer Information */}
                  <div className="mb-2">
                    <label htmlFor="customerName" className="form-label">Họ và tên</label>
                    <input type="text" className="form-control" id="customerName" required />
                  </div>
                  <div className="mb-2">
                    <label htmlFor="customerPhone" className="form-label">Số điện thoại</label>
                    <input type="tel" className="form-control" id="customerPhone" required />
                  </div>
                  <div className="mb-2">
                    <label htmlFor="orderContent" className="form-label">Nội dung đặt hàng</label>
                    <textarea className="form-control" id="orderContent" rows="2"></textarea>
                  </div>

                  {/* Voucher Section */}
                  <div className="mb-2">
                    <label htmlFor="voucherCode" className="form-label">Mã giảm giá (nếu có)</label>
                    <div className="input-group">
                      <input 
                        type="text" 
                        className="form-control" 
                        id="voucherCode" 
                        placeholder="Nhập mã giảm giá"
                      />
                      <button 
                        className="btn btn-outline-primary" 
                        type="button"
                        onClick={async () => {
                          const voucherCode = document.getElementById('voucherCode').value;
                          if (voucherCode) {
                            await checkVoucher(voucherCode);
                          } else {
                            setVoucherError('Vui lòng nhập mã giảm giá');
                          }
                        }}
                      >
                        Áp dụng
                      </button>
                    </div>
                    {voucherError && <div className="text-danger mt-2">{voucherError}</div>}
                    {voucherDiscount > 0 && (
                      <div className="text-success mt-2">
                        Mã giảm giá hợp lệ! Bạn được giảm {voucherDiscount}%
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Total Price Section */}
              <div className="total-price-section mt-4 p-3" 
                   style={{ 
                     background: '#f8f9fa', 
                     borderRadius: '10px',
                     border: '1px solid #e0e0e0'
                   }}>
                <div className="price-breakdown">
                  <div className="row mb-2">
                    <div className="col-6">
                      <span className="text-muted">Giá tạm tính:</span>
                    </div>
                    <div className="col-6 text-end">
                      <span>{totalPrice.original.toLocaleString()}đ</span>
                    </div>
                  </div>
                  {voucherDiscount > 0 && (
                    <div className="row mb-2">
                      <div className="col-6">
                        <span className="text-success">Giảm giá ({voucherDiscount}%):</span>
                      </div>
                      <div className="col-6 text-end">
                        <span className="text-success">-{totalPrice.discount.toLocaleString()}đ</span>
                      </div>
                    </div>
                  )}
                  <div className="row pt-2" style={{ borderTop: '1px solid #e0e0e0' }}>
                    <div className="col-6">
                      <h5 className="mb-0">Tổng cộng:</h5>
                    </div>
                    <div className="col-6 text-end">
                      <h4 className="mb-0 text-primary">
                        {totalPrice.final.toLocaleString()}đ
                      </h4>
                    </div>
                  </div>
                </div>
              </div>

              {/* Footer Buttons */}
              <div className="modal-footer" style={{ borderTop: 'none', padding: '1rem 0 0' }}>
                <div className="d-flex justify-content-between gap-2 w-100">
                  <button type="button" 
                          className="btn btn-secondary" 
                          data-bs-dismiss="modal" 
                          style={{ 
                            borderRadius: '25px', 
                            padding: '8px 20px',
                            minWidth: '120px',
                            width: '100%',
                            marginTop: '10px' 
                          }}>
                    Đóng
                  </button>
                  <button type="submit" 
                          className="btn btn-primary" 
                          style={{ 
                            borderRadius: '25px', 
                            padding: '8px 20px',
                            minWidth: '120px',
                            width: '100%',
                            marginTop: '10px'
                          }}
                          disabled={isSubmitting}>
                    {isSubmitting ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Đang gửi...
                      </>
                    ) : 'Gửi đơn hàng'}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderModal; 